(() => {
  if (window.__soolerMegaMenuImageFallback) return;
  window.__soolerMegaMenuImageFallback = true;

  const selector = '[data-sooler-collection-products-url]';
  const requestCache = new Map();

  const resizeShopifyImage = (source) => {
    try {
      const url = new URL(source, window.location.origin);
      url.searchParams.set('width', '720');
      return url.href;
    } catch (_error) {
      return source;
    }
  };

  const firstProductImage = (productsUrl) => {
    if (!requestCache.has(productsUrl)) {
      requestCache.set(
        productsUrl,
        fetch(productsUrl, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        })
          .then((response) => {
            if (!response.ok) throw new Error(`Collection products request failed: ${response.status}`);
            return response.json();
          })
          .then((payload) => {
            const product = payload.products?.[0];
            const image = product?.image || product?.featured_image || product?.images?.[0];
            const source = typeof image === 'string' ? image : image?.src;
            return source ? resizeShopifyImage(source) : null;
          })
          .catch(() => null),
      );
    }

    return requestCache.get(productsUrl);
  };

  const hydrateImage = async (frame) => {
    if (frame.dataset.soolerImageState) return;
    frame.dataset.soolerImageState = 'loading';

    const source = await firstProductImage(frame.dataset.soolerCollectionProductsUrl);
    if (!source) {
      frame.dataset.soolerImageState = 'empty';
      return;
    }

    const image = document.createElement('img');
    image.alt = '';
    image.decoding = 'async';
    image.fetchPriority = 'low';
    image.loading = 'eager';

    image.addEventListener(
      'load',
      () => {
        frame.classList.remove('is-empty');
        frame.dataset.soolerImageState = 'loaded';

        const item = frame.closest('.sooler-mega-menu__item, .sooler-mega-menu__heading');
        item?.classList.remove('is-missing-image');
        item?.classList.add('has-image');
      },
      { once: true },
    );

    image.addEventListener(
      'error',
      () => {
        image.remove();
        frame.dataset.soolerImageState = 'error';
      },
      { once: true },
    );

    frame.append(image);
    image.src = source;
  };

  const hydrateMenu = (menu) => {
    menu.querySelectorAll(selector).forEach((frame) => hydrateImage(frame));
  };

  const initializeMenu = (menu) => {
    if (menu.dataset.soolerImageFallbackReady) return;
    menu.dataset.soolerImageFallbackReady = 'true';

    const hydrate = () => hydrateMenu(menu);
    const activationTarget = menu.parentElement || menu;
    activationTarget.addEventListener('pointerenter', hydrate, { once: true });
    activationTarget.addEventListener('focusin', hydrate, { once: true });
    window.setTimeout(hydrate, 800);
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('.sooler-mega-menu').forEach(initializeMenu);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
